<template>
  <LayoutDefaultHeader />
  <LayoutDefaultMain>
    <slot />
  </LayoutDefaultMain>
  <LayoutDefaultFooter />
  <AuthenticationPopup />
</template>
